export default {"src":"/_next/static/media/node-js-logo.b540d166.svg","height":58,"width":95,"blurWidth":0,"blurHeight":0};